export const videoMock = [
  { title: 'Videos', id: 1, name: 'video', classNames: 'hidden' },
  {
    title: 'Videos',
    id: 2,
    checkboxText: 'Colleagues can see',
    name: 'colleagues_can_see',
    fieldType: 'checkbox',
    classNames: 'w-max',
  },
  // YouTube link input hidden until wired end-to-end.
  // See .claude/plans/video-youtube-link.md
  // {
  //   title: 'Videos',
  //   id: 3,
  //   placeholder: 'YouTube link',
  //   name: 'youtube_link',
  //   fieldType: 'text',
  //   classNames: 'w-full sm:w-72',
  // },
];
